import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useEffect } from 'react';
import { setLanguage } from '../../store/slices/contentSlice';
import { languages } from '../../config/config';
import { postActivateAccount } from '../../store/actions/authActions';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const { authLoading } = useSelector((state) => state.auth);
  const { authContent, language } = useSelector((state) => state.content);
  const [searchParams, setSearchParams] = useSearchParams();

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
  };

  useEffect(() => {
    changeLanguage();
  }, [language, searchParams]);

  const changeLanguage = () => {
    const languageId = searchParams.get('languageId');

    if (languageId) {
      dispatch(setLanguage({ language: languageId == 3 ? languages?.eng : languages?.arb }))
      setSearchParams({})
    }
  }

  const onSubmit = (values) => {
    const api_data = {
      mobileNumber: values?.phoneNumber,
      languageId: isArabic ? 4 : 3,
    };
    dispatch(postActivateAccount(api_data, (res) => navigate('/otp', {
      state: {
        data: { api_data, is_activate_account: true },
      },
    })));
  };

  return {
    TextWeight,
    authLoading,
    onSubmit,
    getContentKey,
    navigate,
    isArabic,
  };
};
